<template>
  <!-- <v-app class="backgroundPage"> -->
    <!-- <v-navigation-drawer app permanent> -->
    <v-container>
      <v-row class="mb-6" v-if="MobileSize">
        <v-col cols="12" md="12" sm="12" xs="12">
          <v-card class="mt-4" max-height="100%" height="700px" style="border-radius: 8px;">
            <v-list nav>
              <v-list-item-group
                color="#27AB9C"
              >
                <v-list-item
                  v-for="(item, i) in userDetailSelling.position === 'sales' ? itemsSales : itemsAdmin"
                  :key="i"
                  :disabled="item.disable"
                  @click="changePage(item.path)"
                >
                  <v-list-item-icon>
                    <v-icon v-text="item.action"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.title" style="font-size: 16px; line-height: 24px;"></v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action v-if="item.title !== 'บัญชีของฉัน'">
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-list-item-action>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card>
        </v-col>
        <!-- </v-navigation-drawer> -->
        <v-col cols="12" md="9">
          <v-main style="padding: 0px;">
            <v-container>
              <v-card max-height="100%" height="100%" class="mt-3">
                <router-view></router-view>
              </v-card>
            </v-container>
          </v-main>
        </v-col>
      </v-row>
    </v-container>
    <!-- <v-footer app></v-footer> -->
  <!-- </v-app> -->
</template>

<script>
import { Decode } from '@/services'
export default {
  // components: {
  //   UserProfile: () => import('@/components/UserProfile/UserProfileUI')
  // },
  created () {
    this.$EventBus.$emit('getPath')
    this.$EventBus.$emit('changeAppBarGracz')
    this.$EventBus.$emit('enableCartGracz')
    this.$EventBus.$on('changeNav', this.changeNav)
    // this.$EventBus.$emit('CheckFooter')
    if (localStorage.getItem('oneData') === null || localStorage.getItem('UserDetailSelling') === null) {
      this.$EventBus.$emit('changeAppBarPanit')
      this.$router.push({ path: '/' }).catch(() => {})
    } else if (localStorage.getItem('UserDetailSelling') !== null) {
      this.userDetailSelling = JSON.parse(Decode.decode(localStorage.getItem('UserDetailSelling')))
    }
    this.changeNav()
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  watch: {
    selectedItem (val) {
      // console.log(val)
    },
    MobileSize (val) {
      if (this.$router.currentRoute.name === 'GraczUserProfileMobile') {
        if (val === true) {
          this.$router.push({ path: '/Order/UserProfileMobile' }).catch(() => {})
        } else {
          this.$router.push({ path: '/Order/UserProfileDetail' }).catch(() => {})
        }
      }
    }
  },
  computed: {
    MobileSize () {
      const { xs } = this.$vuetify.breakpoint
      return !!xs
    }
  },
  data () {
    return {
      selectedItem: 0,
      select: 0,
      itemsSales: [
        { key: 0, action: 'mdi-account', title: 'บัญชีของฉัน', disable: true },
        { key: 1, action: '', title: 'ข้อมูลของฉัน', path: 'Order/UserProfileDetailMobile', disable: false },
        { key: 2, action: '', title: 'รายการสั่งซื้อสินค้า', path: 'Order/SalesOrderMobile', disable: false },
        { key: 3, action: '', title: 'รายชื่อลูกค้า', path: 'Order/SalesCustomerListMobile', disable: false },
        { key: 4, action: '', title: 'แดชบอร์ดรายงานการสั่งซื้อ', path: 'Order/SalesDashbordMobile', disable: false }
      ],
      itemsAdmin: [
        { key: 0, action: 'mdi-account', title: 'บัญชีของฉัน', disable: true },
        { key: 1, action: '', title: 'ข้อมูลของฉัน', path: 'Order/UserProfileDetailMobile', disable: false }
      ],
      itemslist: [],
      userDetailSelling: ''
    }
  },
  methods: {
    changePage (val) {
      this.$router.push(`/${val}`).catch(() => {})
    },
    changeNav () {
      if (this.$router.currentRoute.name === 'GraczUserProfileDetailMobile') {
        this.selectedItem = 0
        this.select = 0
      } else if (this.$router.currentRoute.name === 'GraczUserProfileDetailMobile') {
        this.selectedItem = 1
        this.select = 1
      } else if (this.$router.currentRoute.name === 'GraczSalesOrderMobile') {
        this.selectedItem = 2
        this.select = 2
      } else if (this.$router.currentRoute.name === 'GraczSalesCustomerListMobile') {
        this.selectedItem = 3
        this.select = 3
      } else if (this.$router.currentRoute.name === 'SalesGraczDashbordMobile') {
        this.selectedItem = 4
        this.select = 4
      }
    }
  }
}
</script>

<style scoped>
.backgroundPage{
  background-color: #F6F6F6;
}
.container {
  max-width: 100%;
}
.v-application ul, .v-application ol {
    padding: 0px 0px !important;
}
.v-application ol, .v-application ul {
    padding: 0px 0px !important;
}
</style>
